import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function BankingLicense (){
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.banking-license.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>

            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/banking-license"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/banking-license-hero.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        subtitle={tp('why.subtitle')}
                        blocks={[{ items: obj('why.items') }]}
                    />

                    <LocationTimeline
                        title={tp('types.title')}
                        item={obj('types.items')}
                    />

                    <InfoBlocks
                        title={tp('jurisdictions.title')}
                        blocks={obj('jurisdictions.blocks')}
                    />


                    <ServiceCards
                        title={tp('services.title')}
                        services={obj('services.items')}
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title={tp('timeline.title')}
                        items={obj('timeline.items')}
                        end={tp('timeline.end')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    {/* Final CTA */}
                    <CTA title={tp('cta.title')}
                         description={tp('cta.description')}
                         buttonText={tp('cta.button')}
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};
